import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";

import { useSelector } from "react-redux";

import { ReactComponent as JKLogo } from "_assets/images/jk.svg";

import "./nav.scss";

const NavItem = ({ name, Actyve, onClick }) => {
  return (
    <>
      <div className={"nav-item" + (Actyve ? " Actyve" : "")} onClick={onClick}>
        {/* <span>
          <Icon />
        </span> */}
        <span> {name} </span>
      </div>
    </>
  );
};

const Empty = () => <> </>;

const Nav = () => {
  const location = useLocation();
  const history = useHistory();
  const { SAP_ID } = useParams();
  const [ActyvePath, setActyvePath] = useState();

  const { loading, user } = useSelector((state) => state.user);

  const logoutUser = () => {
    localStorage.setItem("token", "");
    history.push("/");
    window.location.reload();
  };
  const { role } = user
  // console.log("tyu", role)
  const AONavbar = [
    {
      name: "Dashboard",
      link: "/dashboard",
    },
    {
      name: "Home",
      link: "/",
    },
    {
      name: "Visit Stats",
      link: "/visit-stats",
    },
    {
      name: "Task Stats",
      link: "/task-stats",
    },
    {
      name: "Dealer Location",
      link: "/update-location",
    },

    {
      name: "Holiday",
      link: "/holiday",
    },
    {
      name: "Attendance",
      link: "/attendance-data",
    },
    // {
    //   name: "Upload Docs",
    //   link: "/upload-documents",
    // },
    {
      name: "Dealer Churn",
      link: "/dealer-churn",
    },
    {
      name: "Ticketing",
      link: "/dealer-help-desk",
    },
    {
      name: "Actyv AI",
      link: "/actyv-ai",
    },
    {
      name: "Reports",
      link: "/vists-download",
    },
    {
      name: "Dealer Directory",
      link: "/dealer-directory",
    },
    {
      name: "Switch Beat Requests",
      link: "/switch-beat",
    },
    {
      name: "Sync",
      link: "/sync",
    },
    {
      name: "Onboard",
      link: "/onboard",
    },
  

    {
      name: "Logout",
      execute: logoutUser,
      icon: Empty,
    },
  ];

  const ADMINNavbar = [
    {
      name: "Dashboard",
      link: "/dashboard",
    },
    {
      name: "Home",
      link: "/",
    },
    {
      name: "Visit Stats",
      link: "/visit-stats",
    },
    {
      name: "Task Stats",
      link: "/task-stats",
    },
    {
      name: "Dealer Location",
      link: "/update-location",
    },
    {
      name: "Dealer Churn",
      link: "/dealer-churn",
    },
    {
      name: "Market Research",
      link: "/market-research",
    },
    // {
    //   name: "Expense Dashboard",
    //   link: "/expense-dash",
    // },
    {
      name: "Actyv AI",
      link: "/actyv-ai",
    },
    {
      name: "Ticketing",
      link: "/dealer-help-desk",
    },
    {
      name: "Wear Nature",
      link: "/wear-nature",
    },
    {
      name: "Survey",
      link: "/survey",
    },
    {
      name: "Survey Reconciliation",
      link: "/survey-reconciliation",
    },
    // {
    //   name: "Switch Beat Requests",
    //   link: "/switch-beat",
    // },
    {
      name: "Upload Docs",
      link: "/upload-documents",
    },
    {
      name: "Holiday",
      link: "/holiday",
    },
    {
      name: "Attendance",
      link: "/attendance-data",
    },
    // {
    //   name: "Reimbursements",
    //   link: "/reimbursement",
    // },
    // {
    //   name: "Reimbursement Category",
    //   link: "/reimbursement-category",
    // },
    // {
    //   name: "Spend Limit",
    //   link: "/spend-limit",
    // },
    {
      name: "Reports",
      link: "/vists-download",
    },
    {
      name: "Dealer Directory",
      link: "/dealer-directory",
    },
    {
      name: "SE Depot",
      link: "/se-depot",
    },
    {
      name: "Sync",
      link: "/sync",
    },
    {
      name: "Onboard",
      link: "/onboard",
    },
    {
      name: "Logout",
      execute: logoutUser,
      icon: Empty,
    },
  ];

  const AllNav = [
    {
      name: "Dashboard",
      link: "/dashboard",
    },
    {
      name: "Home",
      link: "/",
    },
    {
      name: "Visit Stats",
      link: "/visit-stats",
    },
    {
      name: "Task Stats",
      link: "/task-stats",
    },
    {
      name: "Dealer Location",
      link: "/update-location",
    },
    {
      name: "Dealer Churn",
      link: "/dealer-churn",
    },
    {
      name: "Holiday",
      link: "/holiday",
    },
    {
      name: "Attendance",
      link: "/attendance-data",
    },
    {
      name: "Actyv AI",
      link: "/actyv-ai",
    },
    // {
    //   name: "Upload Docs",
    //   link: "/upload-documents",
    // },
    {
      name: "Reports",
      link: "/vists-download",
    },
    {
      name:"Ticketing",
      link:"/dealer-help-desk"
    },
    {
      name: "Dealer Directory",
      link: "/dealer-directory",
    },
    {
      name: "Sync",
      link: "/sync",
    },
    {
      name: "Onboard",
      link: "/onboard",
    },
    {
      name: "Logout",
      execute: logoutUser,
      icon: Empty,
    },
  ];
  const ZTMNavbar = [
    {
      name: "Reports",
      link: "/vists-download",
    },
    {
      name: "Logout",
      execute: logoutUser,
      icon: Empty,
    },
  ];

  const ADMINOTRNavbar = [
    {
      name: "Admin OTR",
      link: "/admin-otr",
    },
    {
      name: "Logout",
      execute: logoutUser,
      icon: Empty,
    },
  ];

  let navItems = [];
  // role === "ADMIN"
  //   ? (navItems = ADMINNavbar)
  //   : role === "AO" || role === "RO"
  //     ? (navItems = AONavbar)
  //     : (navItems = AllNav);

  role === "ADMIN"
    ? (navItems = ADMINNavbar)
    : role === "AO" || role === "RO"
      ? (navItems = AONavbar)
      : role === "ZTM"
        ? (navItems = ZTMNavbar)
        : role === "ADMINOTR"
          ? (navItems = ADMINOTRNavbar)
          : (navItems = AllNav);
  // const navItems = [
  //   {
  //     name: "Home",
  //     link: "/",
  //   },
  //   {
  //     name: "Sync",
  //     link: "/sync",
  //   },
  //   {
  //     name: "Dealer Location",
  //     link: "/update-location",
  //   },
  //   {
  //     name: "Switch Beat Requests",
  //     link: "/switch-beat",
  //   },
  //   {
  //     name: "Logout",
  //     execute: logoutUser,
  //     icon: Empty,
  //   },
  // ];
  const navItems1 = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: "PJPs",
      link: `/SO/${SAP_ID}/PJP`,
    },
    {
      name: "Dealer Visits",
      link: `/SO/${SAP_ID}/visits`,
    },
    {
      name: "Secondary Visits",
      link: `/SO/${SAP_ID}/prospectus/visits`,
    },
    {
      name: "Tasks",
      link: `/SO/${SAP_ID}/tasks`,
    },
    {
      name: "Attendance",
      link: `/SO/${SAP_ID}/attendance`,
    },
    {
      name: "Daily Visits",
      link: `/SO/${SAP_ID}/daily`,
    },
    {
      name: "Leads",
      link: `/SO/${SAP_ID}/leads`,
    },
    {
      name: "Time Spent (App)",
      link: `/SO/${SAP_ID}/daily/timespent`,
    },
    {
      name: "Logout",
      execute: logoutUser,
      icon: Empty,
    },
  ];

  useEffect(() => {
    const { pathname } = location;
    setActyvePath(pathname);
  }, [location]);

  const navigateTo = (index) => {
    history.push(navItems[index].link);
  };
  const navigateTo1 = (index) => {
    history.push(navItems1[index].link);
  };

  return (
    <section className="navigation-container">
      <div className="logo" onClick={() => history.push("/")}>
        <JKLogo />
      </div>
      <br /> <br />
      {location.pathname === "/" ||
      location.pathname === "/onboard" ||
      location.pathname === "/sync" ||
      location.pathname === "/update-location" ||
      location.pathname === "/switch-beat" ||
      location.pathname === "/upload-documents" ||
      location.pathname === "/add-documents" ||
      location.pathname === "/vists-download" ||
      location.pathname === `/upload-documents/edit/:id` ||
      location.pathname === "/dashboard" ||
      location.pathname === "/visit-stats" ||
      location.pathname === "/task-stats" ||
      location.pathname === "/wear-nature" ||
      location.pathname === "/dealer-churn" ||
      location.pathname === "/actyv-ai" ||
      location.pathname === "/actyv-ai/" ||
      location.pathname === "/Actyvai/DealerForm" ||
      location.pathname === "/actyv-ai/dealer-form" ||
      location.pathname === "/dealer-help-desk" ||
      location.pathname === "/holiday" ||
      location.pathname === "/dealer-directory" ||
      location.pathname === "/reimbursement" ||
      location.pathname === "/reimbursement-category" ||
      location.pathname === "/attendance-data" ||
      location.pathname === "/expense-dash" ||
      location.pathname === "/spend-limit" ||
      location.pathname === "/survey" ||
      location.pathname === "/survey-reconciliation" ||
      location.pathname === "/market-research" ||
      location.pathname === "/se-depot" ||
      location.pathname === "/admin-otr" ? (
        <div className="scrollBar">
          {navItems.map((item, index) => (
            <NavItem
              Actyve={ActyvePath === item.link}
              key={"nav-" + index}
              name={item.name}
              onClick={item.execute || (() => navigateTo(index))}
            />
          ))}
        </div>
      ) : (
        navItems1.map((item, index) => (
          <>
            <NavItem
              Actyve={ActyvePath === item.link}
              key={"nav-" + index}
              name={item.name}
              onClick={item.execute || (() => navigateTo1(index))}
            />
          </>
        ))
      )}
    </section>
  );
};

export default Nav;
